/**
 * Notification preferences type definitions
 */

export interface NotificationPreferences {
  /**
   * App-wide master toggle for all notifications
   * When false, all notifications are disabled
   */
  notificationsEnabled: boolean;

  /**
   * Enable/disable morning brief AI summary notifications
   * Only active when notificationsEnabled is true
   */
  morningBriefNotificationsEnabled: boolean;

  /**
   * Enable/disable evening recap AI summary notifications
   * Only active when notificationsEnabled is true
   */
  eveningRecapNotificationsEnabled: boolean;
}

/**
 * Default notification preferences for new users
 */
export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  notificationsEnabled: true,
  morningBriefNotificationsEnabled: true,
  eveningRecapNotificationsEnabled: true,
};
